<template>
    <div class="navbar flex items-center p-4">
        <div class="navbar__menu">
            <div>
                <div class="flex items-center">
                    <img v-if="getBrand === 'enigma'" :src="`/images/brandsLogo/${getBrand}/logo.svg`" :alt="getBrand">
                    <h1  v-else style="color: white; text-transform: uppercase;">{{ brandName || 'No Name' }}</h1>
                </div>
            </div>
            <div :class="{'logo_text--enigma': getBrand}" class="logo_text">API documentation</div>
        </div>
        <NavItems
            v-for="(item, index) of navItems"
            :key="index"
            :name="item.name"
            :url="item.url"
            :method="item.method"
        />
    </div>
</template>

<script>
import NavItems from './NavigationItem'
import Logo from '@/layouts/components/Logo'
export default {
    props: {
        navItems: {
            type: Array,
            required: true
        }
    },

    components: {
        NavItems,
        Logo
    },

    computed: {
        getBrand() {
          return this.$store.getters.getBrand
        },

        brandName() {
            return process.env.VUE_APP_API_DOCUMENTATION
        }
    },

    data() {
        return {
            brand: process.env.VUE_APP_BRAND
        }
    }
}
</script>

<style lang="scss">
.navbar {
    .logo_text {
        font-size: 10px;
        color: white;
        margin-top: -5px;
    }

    .logo {
        font-size: 22px;
        font-weight: 600;
    }

    .logo-ml {
        margin-left: 50px;
    }
}
</style>
